import { useEffect, useState } from 'react';

import { faPaperPlane } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';

export const AiInputBar = ({ input, isLoading, onChange, onKeyDown, onSend, t }) => {
    const [shouldHaveBiggerBottomPadding, setShouldHaveBiggerBottomPadding] = useState(() =>
        typeof window === 'undefined' ? true : window.innerHeight < 850
    );

    useEffect(() => {
        const handleResize = () => {
            setShouldHaveBiggerBottomPadding(window.innerHeight < 850);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <div
            className={clsx(
                'sticky bottom-0 z-[2] shrink-0 border-t border-gray-200 bg-gray-100 px-4 pt-2.5',
                shouldHaveBiggerBottomPadding ? 'pb-8' : ' pb-3.5'
            )}
        >
            <div className='relative h-[50px] overflow-hidden rounded-xl border border-gray-300 bg-white shadow-[0_10px_20px_rgba(15,23,42,0.08)] transition-colors focus-within:border-lime-300'>
                <textarea
                    value={input}
                    onChange={(event) => onChange(event.target.value)}
                    onKeyDown={onKeyDown}
                    placeholder={t('Ask your question or describe an action...')}
                    disabled={isLoading}
                    rows={1}
                    className='min-h-[44px] w-full resize-none border-none bg-transparent px-3.5 py-3 pr-12 text-[14px] leading-[1.35] text-gray-800 outline-none focus:outline-none focus:ring-0 focus-visible:outline-none'
                />
                <button
                    type='button'
                    onClick={onSend}
                    disabled={isLoading || !input.trim()}
                    className={clsx(
                        'absolute right-1.5 top-1/2 flex size-[30px] -translate-y-1/2 items-center justify-center rounded-lg border-none text-[12px] text-white transition-all',
                        isLoading || !input.trim() ? 'cursor-not-allowed bg-gray-300' : 'cursor-pointer bg-[#05070d]'
                    )}
                >
                    <FontAwesomeIcon icon={faPaperPlane} />
                </button>
            </div>
            <div className='mt-2 flex items-center text-[10px] text-gray-500'>
                <span>
                    <kbd className='rounded border border-gray-300 bg-white px-1.5 py-0.5 text-[10px]'>
                        {t('Enter')}
                    </kbd>{' '}
                    {t('Send')}
                    {' · '}
                    <kbd className='rounded border border-gray-300 bg-white px-1.5 py-0.5 text-[10px]'>
                        {t('Shift+Enter')}
                    </kbd>{' '}
                    {t('New line')}
                </span>
            </div>
        </div>
    );
};
